import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import SelectInput from './select'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import { FormGroup, Checkbox } from 'react-bootstrap'

@observer
class VideoTypeInput extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
    errors: PropTypes.object,
    store: PropTypes.object.isRequired,
    updateField: PropTypes.func.isRequired,
    validationSuccess: PropTypes.bool
  }

  render () {
    const { store, updateField, validationSuccess, disabled, errors } = this.props
    const errorText = store.cv.errors
      ? (store.cv.errors.get('video_type') || store.cv.errors.get('season_no') || store.cv.errors.get('episode_no') || store.cv.errors.get('parent_id'))
      : undefined
    const validationState = errorText ? 'error' : (validationSuccess ? 'success' : null)
    const value = store.cv.record.get('video_type')

    const seasonParentFilterFc = val => val === Object(val) && 'video_type' in val && val.video_type.toLowerCase() !== 'series'
    const episodeParentFilterFc = val => val === Object(val) && 'video_type' in val && val.video_type.toLowerCase() !== 'season'
    const bundleFilter = val => val.label.toLowerCase() === 'bundle'
    const reverseOrder = store.cv.record && store.cv.record.has('reverse_order') && store.cv.record.get('reverse_order')
    const reverseOrderGlobal = (store.cv.record && store.cv.record.has('reverseOrder') && store.cv.record.get('reverseOrder')) || {}
    const recordID = store.cv.record && store.cv.record.has('id') && parseInt(store.cv.record.get('id'))
    const confirmText = store.__('Change all seasons "reverse order" flags in same way?')

    const onUpdateParent = (k, v) => {
      const f = store.options.get('films').find(i => i.id && parseInt(i.id) === parseInt(v))
      f && f.reverse_order !== undefined && updateField('reverse_order', f.reverse_order)
      return updateField(k, v)
    }
    const onUpdateItem = (k, v, all = false) => {
      if (k && k > 0) {
        reverseOrderGlobal[k] = v
        if (all && value === 'SERIES') {
          store.options.get('seasons')
            .filter(i => i.parent_id && parseInt(i.parent_id) === k)
            .map(j => { reverseOrderGlobal[j.id] = v })
        }
      }
      store.cv.record.set('reverse_order', v)
    }

    return (
      <FormGroup controlId={'video_type_all'}>
        <SelectInput record={store.cv.record} attr={'video_type'} onChange={updateField} errors={errors}
          valueFilterFc={value !== 'BUNDLE' && bundleFilter} labelattr={t => t.value.toUpperCase()}
          label={store.__('video type')} optionsrecord={store.options} disabled={disabled} />
        {value === 'EPISODE' && (
          <SelectInput record={store.cv.record} attr={'parent_id'} onChange={updateField} errors={errors}
            label={store.__('parental season')} labelattr={'title'}
            valueFilterFc={episodeParentFilterFc}
            optionsrecord={store.options} optionsattr={'films'} valueattr={'id'} disabled={disabled} />
        )}
        {value === 'SEASON' && (
          <SelectInput record={store.cv.record} attr={'parent_id'} onChange={(k, v) => onUpdateParent(k, v)} errors={errors}
            label={store.__('parental series')} labelattr={'title'}
            valueFilterFc={seasonParentFilterFc}
            optionsrecord={store.options} optionsattr={'films'} valueattr={'id'} disabled={disabled} />
        )}
        {value === 'EPISODE' && (
          <TextInput label={store.__('episode number')} attr={'episode_no'} record={store.cv.record} errors={errors}
            onChange={updateField} disabled={disabled} />
        )}
        {value === 'SEASON' && (
          <TextInput label={store.__('season number')} attr={'season_no'} record={store.cv.record} errors={errors}
            onChange={updateField} disabled={disabled} />
        )}
        {(value === 'SERIES' || value === 'SEASON') && (
          <Checkbox checked={reverseOrder} id={'reverse_order'} name={'reverse_order'}
            onChange={() => (value === 'SERIES' && window.confirm(confirmText)) ? onUpdateItem(recordID, !reverseOrder, true) : onUpdateItem(recordID, !reverseOrder, false)}>
            {value === 'SERIES' ? store.__('Show seasons in reverse order') : store.__('Show episodes in reverse order')}
          </Checkbox>
        )}
      </FormGroup>
    )
  }
}
export default VideoTypeInput
